<!-- Slot machine example -->
<div #casino id="casino" style="display: none;">
    <div class="content">
      <div>
        <div #casino1 id="casino1" class="slotMachine" style="margin-left: -65px;">
          <div class="slot slot1"></div>
          <div class="slot slot2"></div>
          <div class="slot slot3"></div>
        </div>
  
        <div #casino2 id="casino2" class="slotMachine">
          <div class="slot slot1"></div>
          <div class="slot slot2"></div>
          <div class="slot slot3"></div>
        </div>
  
        <div #casino3 id="casino3" class="slotMachine">
          <div class="slot slot1"></div>
          <div class="slot slot2"></div>
          <div class="slot slot3"></div>
        </div>
      </div>
    </div>
</div>

<div class="animation-container">
  <div #animation1 class="animation" style="opacity: 0;"></div>
  <div #animation2 class="animation" style="opacity: 0;"></div>
  <div #animation3 class="animation" style="opacity: 0;"></div>
</div>

<div class="slot-container">
  <div #slot1 class="slot-100 slot1-img" style="opacity: 1;"></div>
  <div #slot2 class="slot-100 slot2-img" style="opacity: 1;"></div>
  <div #slot3 class="slot-100 slot3-img" style="opacity: 1;"></div>
</div> 

<div #casinoShuffle id="casinoShuffle" class="button-slot">
</div>

<div #text1 id="text1" class="text-1">
  Presiona sobre la palanca para iniciar
</div>

<div class="footer">
  <img class="bbb-logo" src="../../assets/bed-bath-logo.png" alt="bbb-logo">
  <img class="bf-logo" src="../../assets/buen-fin-logo@3x.png" alt="bf-logo">
</div>
